import typeIcon from "../../assets/icons/contentCart/type.svg";
import {theme} from "../../styles/theme.js";
import SVGIcon from "../svgicon/index.jsx";
import {TypeText, TypeWrapper} from "./styles.js";

const typeProperties = {
  green: {
    text: "Le Guide Vert",
    color: theme?.colors?.typeGreen,
    borderColor: theme?.colors?.typeGreenDark,
  },
  red: {
    text: "Guide Michelin",
    color: theme?.colors?.typeRed,
    borderColor: theme?.colors?.typeRedDark,
  },
  orange: {
    text: "Guide Michelin",
    color: theme?.colors?.typeOrange,
    borderColor: theme?.colors?.typeOrangeDark,
  },
};

export const Type = ({source = "green"}) => {
  const {acf, name} = source;
  const {color, picto} = acf;
  return (
    <TypeWrapper color={color} borderColor={color}>
      <TypeText>{name}</TypeText>
      {picto && <img alt={"picto"} src={picto} width={20} height={20} />}
    </TypeWrapper>
  );
};
